// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__RjFYx","header":"PatientQuestionnaire_header__3s0sj","info":"PatientQuestionnaire_info__2lrxQ"};